import { render, staticRenderFns } from "./bannerSet.vue?vue&type=template&id=213af1e2&scoped=true&"
import script from "./bannerSet.vue?vue&type=script&lang=js&"
export * from "./bannerSet.vue?vue&type=script&lang=js&"
import style0 from "./bannerSet.vue?vue&type=style&index=0&id=213af1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213af1e2",
  null
  
)

export default component.exports